export default "__VITE_ASSET__CNb3$6px__"